/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicSendValidationCodeRequest {
  /** Номер телефона в формате +79991234567 **/
  phone: string;
  /** Тип **/
  type: EType;
  /** Точка входа для запроса кода валидации **/
  entryPoint?: string;
}

export enum EType {
  /** подтверждение номера телефона **/
  'PhoneNumber' = 'phoneNumber',
  /** подтверждение при смене пароля **/
  'ChangePassword' = 'changePassword',
  /** подтверждение при смене email'а **/
  'ChangeEmail' = 'changeEmail',
  /** подтверждение при смене credit **/
  'ChangeCredit' = 'changeCredit',
  /** Подтверждение для бронирования объявления. **/
  'BookingAnnouncement' = 'bookingAnnouncement',
  /** Подтверждение для аутентификации. **/
  'AuthenticateCode' = 'authenticateCode',
  /** Подтверждение номера застройщиком на форме ОЗ **/
  'NewBuildingCallbackForm' = 'newBuildingCallbackForm',
}
